import { useEffect, useCallback, useState } from 'react';

export const useWindowSize = (immediately = false) => {
  const getSize = () => ({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [size, setSize] = useState(immediately ? getSize : null);
  const updateSize = useCallback(() => setSize(getSize()), []);

  useEffect(() => {
    if (!immediately) {
      updateSize();
    }
    window.addEventListener('resize', updateSize);

    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, [immediately, updateSize]);

  return size;
};

export default useWindowSize;
